var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    _setup.CModal,
    {
      attrs: { title: "Edit Preview", size: "sm" },
      on: { ok: _setup.handleClose, close: _setup.handleClose },
      scopedSlots: _vm._u([
        {
          key: "modal-footer",
          fn: function () {
            return [
              _c(
                "div",
                { staticClass: "d-flex justify-content-between w-100" },
                [
                  _c(_setup.CButton, {
                    attrs: { text: "Cancel", variant: "secondary" },
                    on: { click: _setup.handleClose },
                  }),
                  _vm._v(" "),
                  _c(_setup.CButton, {
                    attrs: { text: "Save", variant: "primary" },
                    on: { click: _setup.savePreview },
                  }),
                ],
                1
              ),
            ]
          },
          proxy: true,
        },
      ]),
      model: {
        value: _setup.isModalOpen,
        callback: function ($$v) {
          _setup.isModalOpen = $$v
        },
        expression: "isModalOpen",
      },
    },
    [
      _c(_setup.ValidationObserver, { ref: "editFormRef" }, [
        _c(
          "div",
          { staticClass: "form-group" },
          [
            _c(_setup.ValidationProvider, {
              attrs: { rules: "required" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function ({ failed }) {
                    return [
                      _c(_setup.CInput, {
                        staticClass: "mb-2",
                        attrs: {
                          label: "Name",
                          "label-class": "text-muted small2",
                          required: "",
                          error: failed,
                          "error-msg": "Enter the name of the preview",
                        },
                        model: {
                          value: _setup.preview.label,
                          callback: function ($$v) {
                            _vm.$set(_setup.preview, "label", $$v)
                          },
                          expression: "preview.label",
                        },
                      }),
                    ]
                  },
                },
              ]),
            }),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }